// (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

import Main from './components/Main';
import Login from './components/Login';
import SiteView from './components/site/SiteView';
import Alerts from './components/site/Alerts';
import Dashboard from './components/dashboard/Dashboard';
import LocationView from './components/location/LocationView';
import Settings from './components/settings/Settings';
import ChooseLocationMap from './components/settings/ChooseLocationMap';
import AddStem from './components/dashboard/AddStem';
import SubscriptionView from './components/subscription/SubscriptionView';
import SignUp from './components/SignUp';
import Tutorial from './components/tutorial/Tutorial';
// import TBD from 'grommet/components/TBD';

export let routes = [
  {
    path: '/', component: Main, indexRoute: { component: Login },
    childRoutes: [
      { path: 'login', component: Login },
      { path: 'signup', component: SignUp },
      { path: 'location', component: LocationView },
      { path: 'site', component: SiteView },
      // { path: 'dashboard', component: Dashboard },
      { path: 'tutorial', component: Tutorial},
      { path: 'addstem', component: AddStem },
      { path: 'subscription', component: SubscriptionView },
      { path: 'settings', component: Settings },
      { path: 'chooselocation', component: ChooseLocationMap },
      { path: 'alerts', component: Alerts },
      { path: '**', component: Login }
    ]
  },
  { path: '**', component: Login }
];



// WEBPACK FOOTER //
// ./src/js/Routes.js